import { createContext, useContext, useEffect, useState } from "react";
import MessagesApi from "../api_calls/MessagesApi";

const UnreadContext = createContext(null);

export const useUnread = () => useContext(UnreadContext);

export function UnreadProvider({ children }) {
  const [unreadCount, setUnreadCount] = useState(0);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    MessagesApi.getUnreadCount()
      .then((res) => {
        setUnreadCount(res?.data?.unread_count ?? 0);
      })
      .catch(() => {
        setUnreadCount(0);
      })
      .finally(() => setLoading(false));
  }, []);

  return (
    <UnreadContext.Provider value={{ unreadCount, loading, setUnreadCount }}>
      {children}
    </UnreadContext.Provider>
  );
}
